import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20artistic%20Korean%20manhwa%20style%20illustration%20with%20warm%20gradient%20background%2C%20soft%20painterly%20brush%20strokes%20in%20coral%20and%20warm%20golden%20tones%2C%20dreamy%20atmospheric%20composition%20with%20subtle%20comic%20panel%20line%20art%20elements%2C%20elegant%20and%20artistic%2C%20no%20text&width=1800&height=900&seq=hero-bg-hanman&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          韩漫在线观看
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          免费漫画下拉式阅读，漫画韩漫网址首选。通过专属网址享受极速在线观看，智能预加载确保流畅浏览，看韩漫就上韩漫网站。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/category/completed"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full text-sm font-semibold hover:bg-background-50/30 transition-all duration-300 border border-background-50/30 whitespace-nowrap"
          >
            完结漫画
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: 'ri-flashlight-line', text: '极速加载' },
            { icon: 'ri-smartphone-line', text: '下拉式阅读' },
            { icon: 'ri-shield-check-line', text: '免费畅读' },
            { icon: 'ri-refresh-line', text: '每日更新' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2 text-background-50/70 text-sm">
              <i className={`${item.icon} text-accent-500 w-4 h-4 flex items-center justify-center`}></i>
              <span className="whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}